var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isVisible)?_c('div',{staticClass:"kt-container mt-5"},[_c('b-alert',{staticClass:"text-center align-middle",attrs:{"show":"","variant":"warning"}},[_vm._v(_vm._s(_vm.$t("INFORMATIONS.REVENUE_DATA_START")))])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }